import React from "react";
import { Route, Routes } from "react-router-dom";
import { HomePageURL } from "../assets/const";
import FGDetail from "../pages/fg/FGDetail";
import FGList from "../pages/fg/FGList";
import Bundles from "../pages/fg/Bundles";

const FGRoute = () => {
  return (
    <Routes>
      <Route path={`${HomePageURL}/fg/`} element={<FGList />} />
      <Route path={`${HomePageURL}/fg/bundles/`} element={<Bundles />} />
      <Route path={`${HomePageURL}/fg/:fgId/`} element={<FGDetail />} />
    </Routes>
  );
};

export default FGRoute;
